module.exports = __webpack_public_path__ + "static/media/img18.f3f4e872.JPG";